module.exports = __webpack_public_path__ + "static/media/current-location.af94fc86.png";